<script setup>
defineProps({
    value: {
        type: String,
        default: '',
    },
    isRequired: {
        type: Boolean,
        default: false,
    },
})
</script>

<template>
    <label class="text-on-surface-variant mb-2 ml-1 block text-xs font-bold tracking-widest uppercase">
        <slot>
            {{ value }}
            <span
                class="text-primary-container"
                v-if="isRequired"
                >*</span
            >
        </slot>
    </label>
</template>
